import { Component, Input } from '@angular/core';
import { DashboardCard } from 'src/app/models/dashboard.model';

@Component({
  standalone: false,
  selector: 'app-stat-card',
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.scss']
})
export class StatCardComponent {
  @Input() card!: DashboardCard;
}
